type CheckoutCrypto = Pick<Crypto, 'getRandomValues'> & {
  randomUUID?: () => string;
};

const UUID_BYTE_LENGTH = 16;

/**
 * Generate a UUID that works in older WebViews where `crypto.randomUUID` is missing.
 */
export function createCheckoutUuid(): string {
  const cryptoProvider = getCryptoProvider();

  if (typeof cryptoProvider?.randomUUID === 'function') {
    try {
      return cryptoProvider.randomUUID();
    } catch {}
  }

  const bytes = new Uint8Array(UUID_BYTE_LENGTH);

  if (typeof cryptoProvider?.getRandomValues === 'function') {
    try {
      cryptoProvider.getRandomValues(bytes);
    } catch {
      fillWeakRandomBytes(bytes);
    }
  } else {
    fillWeakRandomBytes(bytes);
  }

  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  return formatUuid(bytes);
}

function getCryptoProvider(): CheckoutCrypto | undefined {
  const global = typeof window !== 'undefined' ? window : globalThis;
  return global.crypto as CheckoutCrypto | undefined;
}

function fillWeakRandomBytes(bytes: Uint8Array): void {
  for (let i = 0; i < bytes.length; i += 1) {
    bytes[i] = Math.floor(Math.random() * 256);
  }
}

function formatUuid(bytes: Uint8Array): string {
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0'));

  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join(''),
  ].join('-');
}
